import { useState } from "react";
import { toast } from "sonner";
import { Mail, Copy, Download } from "lucide-react";
import { download } from "@/lib/api";
import { Panel, Field } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const SITE = "https://www.fatturazionegestionale.com";
const OGGETTO = "FatturazioneGestionale: fatture elettroniche, magazzino e cassa in un unico programma";
const TESTO = `Buongiorno,

vi presento FatturazioneGestionale, il gestionale online per aziende, negozi e studi commercialisti:
- fatturazione elettronica con XML FatturaPA controllato
- magazzino, DDT, preventivi e ordini
- corrispettivi e cassa per i negozi
- agenti di vendita dal tablet con calcolo delle provvigioni

Trovate in allegato la presentazione (oppure scaricatela qui: ${SITE}/api/presentazione.pdf).

Potete provarlo gratis per 30 giorni, senza carta di credito: ${SITE}/prova
Siete uno studio commercialista? Scoprite il programma partner: ${SITE}/partner

Resto a disposizione per una dimostrazione.

Cordiali saluti
Generservice Srl Semplificata
clienti@fatturazionegestionale.com

Se non desiderate ricevere altre comunicazioni rispondete a questa email con "CANCELLA".`;

const EMAIL_RE = /[^\s@,;<>"]+@[^\s@,;<>"]+\.[a-z]{2,}/gi;
const GRUPPO = 40;

export const EmailPromo = () => {
  const [lista, setLista] = useState("");
  const [oggetto, setOggetto] = useState(OGGETTO);
  const [testo, setTesto] = useState(TESTO);
  const emails = [...new Set((lista.match(EMAIL_RE) || []).map((e) => e.toLowerCase()))];
  const gruppi = Array.from({ length: Math.ceil(emails.length / GRUPPO) }, (_, n) => emails.slice(n * GRUPPO, (n + 1) * GRUPPO));
  const enc = encodeURIComponent;
  const mailto = (g) => `mailto:?bcc=${g.join(",")}&subject=${enc(oggetto)}&body=${enc(testo)}`;
  const gmail = (g) => `https://mail.google.com/mail/?view=cm&fs=1&bcc=${enc(g.join(","))}&su=${enc(oggetto)}&body=${enc(testo)}`;
  const copia = (t, msg) => navigator.clipboard.writeText(t).then(() => toast.success(msg), () => toast.error("Copia non riuscita"));
  return (
    <Panel title="Email di presentazione (parte dalla tua casella)">
      <div className="grid gap-4 lg:grid-cols-2">
        <div className="space-y-3">
          <Field label="Destinatari (uno per riga, o separati da virgola)">
            <Textarea rows={8} data-testid="promo-recipients" placeholder={"studio.rossi@esempio.it\ninfo@azienda.it"} value={lista} onChange={(e) => setLista(e.target.value)} />
          </Field>
          <p className="text-sm text-slate-600" data-testid="promo-count">{emails.length} indirizzi validi{gruppi.length > 1 ? ` · divisi in ${gruppi.length} gruppi da max ${GRUPPO}` : ""}</p>
          <Field label="Oggetto"><Input data-testid="promo-subject" value={oggetto} onChange={(e) => setOggetto(e.target.value)} /></Field>
        </div>
        <Field label="Testo dell'email"><Textarea rows={14} data-testid="promo-body" value={testo} onChange={(e) => setTesto(e.target.value)} /></Field>
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        <Button variant="outline" className="bg-white" data-testid="promo-pdf-download" onClick={() => download("/admin/presentazione.pdf").catch((e) => toast.error(e.message))}><Download className="mr-2 h-4 w-4" />Scarica il PDF da allegare</Button>
        <Button variant="outline" className="bg-white" data-testid="promo-copy-emails" disabled={!emails.length} onClick={() => copia(emails.join(", "), "Indirizzi copiati")}><Copy className="mr-2 h-4 w-4" />Copia indirizzi</Button>
        <Button variant="outline" className="bg-white" data-testid="promo-copy-text" onClick={() => copia(testo, "Testo copiato")}><Copy className="mr-2 h-4 w-4" />Copia testo</Button>
      </div>
      {gruppi.map((g, n) => (
        <div key={n} className="mt-3 flex flex-wrap items-center gap-2 rounded-lg border border-sky-200 bg-sky-50 p-3" data-testid={`promo-group-${n}`}>
          <span className="mr-2 text-sm font-semibold text-sky-900">{gruppi.length > 1 ? `Gruppo ${n + 1}` : "Invio"} · {g.length} destinatari in copia nascosta</span>
          <Button asChild className="bg-sky-600 hover:bg-sky-700" data-testid={`promo-open-mail-${n}`}><a href={mailto(g)}><Mail className="mr-2 h-4 w-4" />Apri nel mio programma email</a></Button>
          <Button asChild variant="outline" className="bg-white" data-testid={`promo-open-gmail-${n}`}><a href={gmail(g)} target="_blank" rel="noreferrer">Apri in Gmail</a></Button>
        </div>
      ))}
      <p className="mt-4 text-xs text-slate-500">Il PDF va allegato a mano nel messaggio che si apre (oppure lascia il link nel testo). Scrivi solo a contatti che ti conoscono o che hanno dato il consenso a ricevere comunicazioni.</p>
    </Panel>
  );
};
